// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2PnPW","itemTitle":"ClientEmergencyInfo_itemTitle__2w0ZB","itemText":"ClientEmergencyInfo_itemText__2GD3n"};